import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../utils/empty-reference';

export const _initialState = {
  cabinetVisualizer: {
    styleChoiceId: null,
    defaultStyleChoiceId: null, // Store default choice for temp design creation
    userSelectedStyleChoice: false, // Flag to track if user explicitly selected a collection
    isLandingPage: false, // Flag to track if this is a landing page
    choices: null,
    options: null,
    choiceMetadata: null,
    // Project-based structure
    projects: EMPTY_OBJECT, // New: Store project metadata
    currentProjectId: null, // New: Track active project
    userSelectedCollection: null,
    // Existing design structure (maintained for compatibility)
    designs: EMPTY_OBJECT,
    designIds: EMPTY_ARRAY,
    styleDesignIds: EMPTY_ARRAY,
    selectedDesignId: null,
    // Migration metadata
    _migrationInfo: null, // Track migration status and details
    itemPrices: EMPTY_ARRAY,
    toeKickMetadata: EMPTY_OBJECT,
    skuDrawer: {
      selectedParentId: null,
      selectedItemId: null,
      superSkuProducts: EMPTY_ARRAY,
      modalTypes: EMPTY_OBJECT,
      modalAssortment: EMPTY_OBJECT,
      attributePriority: EMPTY_ARRAY,
      spacerModalOpen: false,
    },
    // Analytics tracking
    prevAnalyticsFilterGroups: {},
    hasFiredInitialRefinementsEvent: false,
  }
};
